import PropTypes from 'prop-types';

const propType = {
  name: PropTypes.string,
  stats: PropTypes.shape({ total: PropTypes.number }),
  translationKey: PropTypes.string.isRequired,
  imageURL: PropTypes.string.isRequired,
};

export default { propType };
